import '../../../ProductCard/ProductCard.scss';
import './Wrapper.scss';

import classnames from 'classnames';
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';

import loadable from '@loadable/component';

import { useIsBelowSmallOnly } from '../../../../hooks/mediaQueries';
import { useEventListener } from '../../../../hooks/useEventListener';
import { isProductInTradingRange } from '../../../../utilities/product-utilities';
import { Context } from '../../store/store';
import CustomCategoryMobileProductCard from '../MobileViewContent/CustomCategoryMobileProductCard@default';

const RecommendationCarousel = loadable(() =>
	import('../../../ProductCard/RecommendationCarousel/RecommendationCarousel')
);

const Content = ({ index, product, tradingRangeInfo }) => {
	const { ListerAlternativeProductsEnabled } = useSelector(
		(state) => state.experimentSwitches
	);

	return (
		<React.Fragment>
			<div className="flex flex-col pb-0">
				<meta itemProp="position" content={index} />

				<CustomCategoryMobileProductCard {...{ product, tradingRangeInfo }} />
			</div>

			{ListerAlternativeProductsEnabled && product.State === 'OutOfStock' && (
				<RecommendationCarousel NowPrice={product.PricePodViewModel.NowPrice} />
			)}
		</React.Fragment>
	);
};
const Wrapper = ({ product, index, isFeatured }) => {
	const [state, dispatch] = useContext(Context);
	const { loaded } = state;

	useEventListener(`lazy-load-${product.ColourId}`, () => {
		dispatch({ type: 'UPDATE_LOADED', payload: true });
	});

	const isBelowSmallOnly = useIsBelowSmallOnly();
	const tradingRangeInfo = isProductInTradingRange(product.Code);

	const props = {
		id: product.Code,
		className: classnames(
			'relative h-full w-full bg-white p-4 sm:px-4 border-gray-30',
			{
				'rounded-sm': isFeatured,
				'm-2 lg:mx-4 mobileCard__wrapper rounded': !isFeatured,
				'border border-solid': loaded && !isFeatured,
				'pt-8': tradingRangeInfo && loaded,
				'pt-3': isBelowSmallOnly && loaded,
			}
		),
		itemProp: 'itemListElement',
		itemScope: true,
		itemType: 'http://schema.org/ListItem',
		['data-productcode']: product.Code,
		['data-testid']: 'product-card-list-view',
		['data-lazy-sku']: product.ColourId,
	};

	return React.createElement(
		isFeatured ? 'div' : 'li',
		props,
		<Content {...{ index, product, tradingRangeInfo }} />
	);
};

export default Wrapper;
